import React from "react";

export default function statisticsPopupTemplate () {
    return (
        <React.Fragment>
            <div className="ticket-results-view-p">
                <iframe src={this.props.url} className="statistics-iframe"/>
            </div>
        </React.Fragment>
    );
}